import { Partner } from "types/Partner";
import { Society } from "types/Society";

type GetHoldingReferenceProps = {
  index: number,
  partners: Partner[],
  previousSocieties: Society[],
  actualSociety: Society
}

export const getHoldingReference = ({
  index,
  partners,
  previousSocieties,
  actualSociety
}: GetHoldingReferenceProps) => {
  if (index === 0) {
    return [actualSociety._id];
  }

  const societyReferenceIds: string[] = [];

  previousSocieties.forEach((previousSociety) => {
    const isPartner = partners?.find(
      (partner) => partner?.cif === previousSociety?.cif
    );

    if (isPartner) {
      societyReferenceIds.push(previousSociety._id);
    }
  });

  return societyReferenceIds.length ? societyReferenceIds : null;
};
